module.exports = "/img/sports_car.068a4508.png";